( ( $ ) => {

	const headerHeight = $( '.site-header' ).outerHeight();
	$( 'a.scroll-to, li.scroll-to > a' ).each( ( index, el ) => {
		const link = el;
		let linkURL = link.getAttribute( 'href' );
		let linkParts = linkURL.split( '#' );
		if ( linkParts[0] && linkParts[0] !== window.location.pathname ) {
			return;
		}
		linkURL = '#' + linkParts[1];
		if (
			linkURL &&
			linkURL.indexOf( 'http' ) === -1 &&
			linkURL.indexOf( '#' ) !== -1 &&
			'#' !== linkURL
		) {
			link.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				if ( $( linkURL ).length > 0 ) {
					const top = $( linkURL ).offset().top - headerHeight;
					$( 'html:not(:animated), body:not(:animated)' ).animate(
						{ scrollTop: top },
						500
					);
				}
			} );
		}
	} );

} )( jQuery )